import * as React from 'react';

interface IProps {
    // Without the box and the row of its own, to sit among other things, such as next to the buttons of a page heading
    inline?: boolean;
}

export const MetricTableLegend = (props : IProps) => {

    const legend = (
        <div className={`scheduling-legend ${ props.inline ? 'inline' : '' }`}>
            <h4>Legend:</h4>
            <h4 className="open-before">Open</h4>
            <h4 className="printed-before">Printed</h4>
            <h4 className="complete-before">Complete</h4>
        </div>
    );

    return props.inline
        ? legend
        : (
            <div className="row full-bleed">
                <div className="col">
                    { legend }
                </div>
            </div>
        );
}
